import { Badge, Button, Card, CardBody, Divider, HStack, Image, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Stack, Text, useDisclosure } from '@chakra-ui/react';

import CompanyPlaceholder from '../../../theme/assets/company-placeholder.png';
import { FiMail } from 'react-icons/fi';
import { IoCheckmarkCircle } from 'react-icons/io5';
import React from 'react';
import { RequestWebsite } from '../RequestWebsite';
import { TbWorldWww } from 'react-icons/tb';

type partnerCardProps = {
    name: string;
    category: string;
    email: string;
    phone: string;
    website: string;
    services: string[];
    requestable: boolean;
};

export const PartnerCard = ({ name, category, email, phone, website, services, requestable }: partnerCardProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    return (
        <>
            <Card>
                <CardBody>
                    <HStack>
                        <Image
                            boxSize='50px'
                            alt={'logo'}
                            src={CompanyPlaceholder}
                        />
                        <Stack>
                            <Text fontSize={'lg'} fontWeight={'semibold'} mb={0}>{name}</Text>
                            <Badge w={'fit-content'} colorScheme={'yellow'} mt={'0 !important'}>{category}</Badge>
                        </Stack>
                    </HStack>
                    <HStack my={1}>
                        <HStack>
                            <FiMail />
                            <Link href={`mailto:${email}`}>{email}</Link>
                        </HStack>
                        <HStack>
                            <FiMail />
                            <Link href={`tel:${phone}`}>{phone}</Link>
                        </HStack>
                    </HStack>
                    <HStack>
                        <TbWorldWww />
                        <Link href={website} isExternal>{website}</Link>
                    </HStack>
                    <Divider my={3} />
                    <Text fontSize={'sm'} fontWeight={'semibold'} mb={2}>Services</Text>
                    {
                        services?.map((service: string, index: number) => (
                            <HStack key={index}>
                                <IoCheckmarkCircle color='#4caf50' />
                                <Text textTransform={'capitalize'}>{service}</Text>
                            </HStack>
                        ))
                    }
                    {
                        requestable && (
                            <HStack justifyContent={'center'}>
                                <Button colorScheme={'yellow'} mt={2} size={'sm'} onClick={onOpen}>Request help/support</Button>
                            </HStack>
                        )
                    }
                </CardBody>
            </Card>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalBody>
                        <RequestWebsite />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};